import { Flex, Icon, Table, TableFooter } from "@evergis/ui";
import styled from "styled-components";

import { AdditionalBlock } from "../Card/styled";

export const CatalogTable = styled(Table)`
  th:first-child,
  td:first-child,
  ${TableFooter} {
    padding-left: 10px;
  }
  ${AdditionalBlock} {
    margin: 0;
  }
  .noActionCell ${Icon} {
    opacity: 0.28;
  }

  tr {
    height: 52px;
  }

  tr .actions {
    visibility: hidden;
  }

  tr:hover .actions {
    visibility: visible;
  }
`;

export const TableControlsContainer = styled(Flex)`
  align-items: center;
  flex-wrap: nowrap;

  > :not(:last-child) {
    margin-right: 30px;
  }
`;

export const TableControlSlot = styled(Flex)`
  min-width: 120px;
  align-items: center;
`;

export const TableNameContainer = styled(Flex)`
  flex-wrap: nowrap;
  align-items: center;
`;

export const TableAlias = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
